import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import CreateQuantityModal from '../component/CreateQuantityModal';
import UpdateQuantityModal from '../component/UpdateQuantityModal';
import * as actions from '../action';
import * as c from '../constant';

function QuantityCalculation({
  newOtherFeesId,
  removeQuantityFees,
  getNewOtherFeesList,
  getSingleNewOtherFees,
  history,
  quantityCalculationList,
  getQuantityCalculationList,
  ordinanceRevisionId,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getQuantityCalculationList(newOtherFeesId);
  }, []);

  useEffect(() => {
    if (_.isEmpty(newOtherFeesId)) return;
    getQuantityCalculationList(newOtherFeesId);
  }, [newOtherFeesId]);

  const handleAddQuantityModal = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: (
        <CreateQuantityModal
          newOtherFeesId={newOtherFeesId}
          quantityCalculationList={quantityCalculationList}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Add Quantity Fee',
      modalSize: 'modal-md',
    });
  };

  const handleEditQuantityModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateQuantityModal
          newOtherFeesId={newOtherFeesId}
          ordinanceRevisionId={ordinanceRevisionId}
          updateList={data.attributes}
          id={data.id}
          quantityCalculationList={quantityCalculationList}
        />
      ),
      title: 'Update Quantity Fee',
      modalSize: 'modal-md',
    });
  };

  const handleRemoveQuantity = (data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure, you want to remove this quantity fee?',
      () => {
        removeQuantityFees(data.id, newOtherFeesId, () => {
          getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
          history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
          getSingleNewOtherFees(newOtherFeesId);
          getQuantityCalculationList(newOtherFeesId);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div>
      <div className="p-3">
        <div className="ml-auto text-right mb-3">
          <button
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold px-4 ml-auto"
            onClick={handleAddQuantityModal}
          >
            Add Quantity Calculation
          </button>
        </div>
        <table className="transaction-table table table-bordered table-sm table-striped table-hover">
          <thead>
            <tr>
              <td>Multiplier</td>
              <td>Amount</td>
              <td className="text-center">Action</td>
            </tr>
          </thead>
          <tbody>
            {!_.isEmpty(quantityCalculationList) ? (
              quantityCalculationList.map((item) => (
                <tr key={item.id} className="top-border">
                  <td className="text-left">
                    {_.get(item, 'attributes.multiplier')}
                  </td>
                  <td className="text-left">
                    {_.get(item, 'attributes.amount')}
                  </td>
                  <td className="text-right">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEditQuantityModal(item)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemoveQuantity(item)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="7">No data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

QuantityCalculation.propTypes = {
  quantityCalculationList: PropTypes.instanceOf(Object).isRequired,
  removeQuantityFees: PropTypes.instanceOf(Function).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getQuantityCalculationList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  quantityCalculationList:
    _.get(api, `${c.GET_QUANTITY_CALCULATION_LIST}.list`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(QuantityCalculation);
